import { Button, CircularProgress, makeStyles } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import React, { useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router';

const useStyles = makeStyles((theme) => ({
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
    // width: '80%',
  },
}));

export function useGlosaries() {
  const [glosaries, setGlosaries] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    setIsLoading(true);
    fetch('https://api.edicionesmilenio.com/api/glosary')
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        setGlosaries(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return { glosaries, setGlosaries, isLoading };
}

export default function Glosaries() {
  const { glosaries, setGlosaries, isLoading } = useGlosaries();
  const [letter, setLetter] = React.useState('');
  const [word, setWord] = React.useState('');
  const [definition, setDefinition] = React.useState('');
  const [selectedGlosary, setSelectedGlosary] = React.useState(null);
  const navigate = useNavigate();

  const routeChange = (id) => {
    // navigate(`/admin/glosaries-update/${id}`);
    window.open(`/admin/glosaries-update/${id}`, '_blank');
  };

  const classes = useStyles();

  const columns = [
    {
      name: 'letter',
      label: 'Letra',
    },
    {
      name: 'word',
      label: 'Palabra',
    },
    {
      name: 'definition',
      label: 'Definición',
      options: {
        filter: false,
      },
    },
    {
      name: 'createdAt',
      label: 'Fecha De Creación',
    },
    {
      name: 'actions',
      label: 'Herramientas',
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <Button
              color="primary"
              onClick={() => routeChange(glosaries[dataIndex]?._id)}
            >
              <FaEdit />
            </Button>
          );
        },
      },
    },
  ];

  const handleDelete = async (rowsDeleted) => {
    const confirm = window.confirm(
      '¿Está seguro que desea eliminar los glosarios seleccionados?'
    );
    if (confirm) {
      rowsDeleted?.data?.forEach(async (row) => {
        let response = await fetch(
          `https://api.edicionesmilenio.com/api/glosary/${
            glosaries[row?.dataIndex]?._id
          }`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              letter,
              word,
              definition,
            }),
          }
        );
        let data = await response.json();
        if (data.success) {
        }
      });
    }
    return true;
  };

  useEffect(() => {
    if (selectedGlosary) {
      setLetter(selectedGlosary?.letter);
      setWord(selectedGlosary?.word);
      setDefinition(selectedGlosary?.definition);
    }
  }, [selectedGlosary]);

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p className={classes.formSpan}>
        Estimado administrador, desde esta sección podrás visualizar la lista de
        términos creados a la fecha, desde esta sección podrás gestionar, cada
        uno de ellos.
      </p>
      {!isLoading ? (
        <MUIDataTable
          title={'Listado de asignaturas'}
          data={glosaries}
          columns={columns}
          options={{
            onRowsDelete: (rowsDeleted) => {
              return handleDelete(rowsDeleted);
            },
          }}
        />
      ) : (
        <CircularProgress color="primary" />
      )}
    </div>
  );
}
